module.exports = __webpack_public_path__ + "web/img/articles1.23eee8ba.png";